var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/map");

var _Array$isArray = require("@babel/runtime-corejs3/core-js-stable/array/is-array");

var ElementType = require("domelementtype"),
    getOuterHTML = require("dom-serializer"),
    isTag = ElementType.isTag;

module.exports = {
  getInnerHTML: getInnerHTML,
  getOuterHTML: getOuterHTML,
  getText: getText
};

function getInnerHTML(elem, opts) {
  var _context;

  return elem.children ? _mapInstanceProperty(_context = elem.children).call(_context, function (elem) {
    return getOuterHTML(elem, opts);
  }).join("") : "";
}

function getText(elem) {
  if (_Array$isArray(elem)) return _mapInstanceProperty(elem).call(elem, getText).join("");
  if (isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
  if (elem.type === ElementType.CDATA) return getText(elem.children);
  if (elem.type === ElementType.Text) return elem.data;
  return "";
}